var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card",
        { attrs: { id: "custom-drafts" } },
        [
          _c(
            "div",
            {
              staticClass: "row col-12",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_c("h3", [_vm._v("Borradores personalizados")])]
          ),
          _c("div", { staticClass: "row mb-3 align-items-end" }, [
            _c("div", { staticClass: "col-md-4" }, [
              _c("label", [_vm._v("Tipo de documento")]),
              _c(
                "select",
                {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.selectedType,
                      expression: "selectedType"
                    }
                  ],
                  staticClass: "form-control",
                  on: {
                    change: function($event) {
                      var $$selectedVal = Array.prototype.filter
                        .call($event.target.options, function(o) {
                          return o.selected
                        })
                        .map(function(o) {
                          var val = "_value" in o ? o._value : o.value
                          return val
                        })
                      _vm.selectedType = $event.target.multiple
                        ? $$selectedVal
                        : $$selectedVal[0]
                    }
                  }
                },
                [
                  _c("option", { attrs: { value: "*" } }, [
                    _vm._v("Selecciona un tipo")
                  ]),
                  _vm._l(_vm.availableTypes, function(type) {
                    return _c(
                      "option",
                      { key: type.value, domProps: { value: type.value } },
                      [_vm._v(" " + _vm._s(type.text || type.value) + " ")]
                    )
                  })
                ],
                2
              )
            ]),
            _c(
              "div",
              { staticClass: "col-md-3 text-right" },
              [
                _c("vs-button", {
                  directives: [
                    {
                      name: "tooltip",
                      rawName: "v-tooltip",
                      value: "Refrescar listado",
                      expression: "'Refrescar listado'"
                    }
                  ],
                  attrs: {
                    color: "primary",
                    type: "border",
                    icon: "refresh",
                    disabled: !_vm.selectedType
                  },
                  on: { click: _vm.fetchDocuments }
                })
              ],
              1
            )
          ]),
          _vm.errorMessage
            ? _c("b-alert", { attrs: { variant: "danger", show: "" } }, [
                _vm._v(" " + _vm._s(_vm.errorMessage) + " ")
              ])
            : _vm._e(),
          !_vm.availableTypes.length
            ? _c("b-alert", { attrs: { variant: "warning", show: "" } }, [
                _vm._v(
                  " No hay tipos de documentos personalizados configurados para esta empresa. "
                )
              ])
            : !_vm.selectedType
            ? _c("b-alert", { attrs: { variant: "info", show: "" } }, [
                _vm._v(
                  " Selecciona un tipo para listar los borradores personalizados. "
                )
              ])
            : _vm._e(),
          _vm.selectedType
            ? _c(
                "b-overlay",
                {
                  attrs: {
                    show: _vm.loading,
                    variant: "white",
                    blur: "0",
                    opacity: "0.75",
                    rounded: "sm"
                  }
                },
                [
                  _c(
                    "div",
                    { key: _vm.forceRender, staticClass: "force-render" },
                    [
                      _c(
                        "table",
                        {
                          staticClass:
                            "table table-hover b-table table-responsive"
                        },
                        [
                          _c("thead", [
                            _c("tr", [
                              _c("th", [_vm._v("Tipo")]),
                              _c("th", [_vm._v("Creado")]),
                              _c("th", [_vm._v("Estado")]),
                              _c("th", { staticClass: "text-center" }, [
                                _vm._v("Acciones")
                              ])
                            ])
                          ]),
                          _c(
                            "tbody",
                            [
                              !_vm.tableItems.length
                                ? _c("tr", [
                                    _c(
                                      "td",
                                      {
                                        staticClass: "text-center",
                                        attrs: { colspan: "4" }
                                      },
                                      [_vm._v("Sin borradores personalizados")]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._l(_vm.tableItems, function(row) {
                                return _c("tr", { key: row.id }, [
                                  _c(
                                    "td",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: row.type,
                                          expression: "row.type"
                                        }
                                      ]
                                    },
                                    [_vm._v(_vm._s(row.typeLabel || row.type))]
                                  ),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(_vm.formatDate(row.createdAt))
                                    )
                                  ]),
                                  _c(
                                    "td",
                                    [
                                      row.statusLabel
                                        ? _c(
                                            "vs-chip",
                                            { attrs: { title: "Borrador" } },
                                            [
                                              _c("vs-avatar", {
                                                attrs: {
                                                  icon: "query_builder",
                                                  color: "#87579e"
                                                }
                                              }),
                                              _vm._v(
                                                " " +
                                                  _vm._s(row.statusLabel) +
                                                  " "
                                              )
                                            ],
                                            1
                                          )
                                        : _c("span", [_vm._v("-")])
                                    ],
                                    1
                                  ),
                                  _c("td", [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "d-flex justify-content-center"
                                      },
                                      [
                                        _c(
                                          "b-dropdown",
                                          {
                                            attrs: {
                                              variant: "link",
                                              "no-caret": "",
                                              right: ""
                                            },
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "button-content",
                                                  fn: function() {
                                                    return [
                                                      _c("feather-icon", {
                                                        staticClass:
                                                          "align-middle text-body",
                                                        attrs: {
                                                          width: "20px",
                                                          height: "20px",
                                                          icon: "SettingsIcon"
                                                        }
                                                      })
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              true
                                            )
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.continueDocument(
                                                      row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("vs-icon", {
                                                  attrs: {
                                                    icon: "query_builder"
                                                  }
                                                }),
                                                _vm._v(" Continuar documento ")
                                              ],
                                              1
                                            ),
                                            _c(
                                              "b-dropdown-item",
                                              {
                                                on: {
                                                  click: function($event) {
                                                    return _vm.discardDocument(
                                                      row
                                                    )
                                                  }
                                                }
                                              },
                                              [
                                                _c("vs-icon", {
                                                  attrs: {
                                                    icon:
                                                      "remove_circle_outline"
                                                  }
                                                }),
                                                _vm._v(" Descartar documento ")
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ])
                                ])
                              })
                            ],
                            2
                          )
                        ]
                      )
                    ]
                  )
                ]
              )
            : _vm._e(),
          _vm.tableItems && _vm.tableItems.length
            ? _c("div", { staticClass: "row col-12" }, [
                _c("div", { staticClass: "col-lg-4" }, [
                  _c("div", { staticClass: "mt-5" }, [
                    _vm._v(" Mostrando "),
                    _c(
                      "select",
                      {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: _vm.rowspp,
                            expression: "rowspp"
                          }
                        ],
                        on: {
                          change: function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.rowspp = $event.target.multiple
                              ? $$selectedVal
                              : $$selectedVal[0]
                          }
                        }
                      },
                      [
                        _c(
                          "option",
                          { attrs: { value: "10", selected: "selected" } },
                          [_vm._v("10")]
                        ),
                        _c("option", { attrs: { value: "15" } }, [
                          _vm._v("15")
                        ]),
                        _c("option", { attrs: { value: "30" } }, [
                          _vm._v("30")
                        ]),
                        _c("option", { attrs: { value: "50" } }, [_vm._v("50")])
                      ]
                    ),
                    _vm._v(" registros por pagina. ")
                  ])
                ]),
                _c(
                  "div",
                  { staticClass: "col-lg-8" },
                  [
                    _c(
                      "vs-row",
                      [
                        _c(
                          "vs-col",
                          { staticClass: "mt-4", attrs: { "vs-w": "12" } },
                          [
                            _c("fb-paginacion", {
                              attrs: { total: _vm.pagination.pages },
                              model: {
                                value: _vm.page,
                                callback: function($$v) {
                                  _vm.page = $$v
                                },
                                expression: "page"
                              }
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }